module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("简历")])], 1), _vm._v(" "), (_vm.isLogin === '1') ? _c('li', {
    staticClass: "menu-btn"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("已登录")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])]) : _c('li', {
    staticClass: "menu-btn"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("登录")])], 1)])])])])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f8fb7c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 260
// module chunks = 1